var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDream5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.4715 46.625V41.2133C57.4715 27.7635 46.5683 16.8604 33.1185 16.8604C19.6688 16.8604 8.76562 27.7635 8.76562 41.2133V46.625",
    stroke: "url(#paint0_linear_6582_55691)",
    strokeWidth: 4.02016,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3573 46.6251V41.2133C49.3573 32.2468 42.0885 24.978 33.122 24.978C24.1555 24.978 16.8867 32.2468 16.8867 41.2133V46.6251",
    stroke: "url(#paint1_linear_6582_55691)",
    strokeWidth: 4.02016,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2392 46.6249V41.2131C41.2392 36.7299 37.6048 33.0955 33.1215 33.0955C28.6383 33.0955 25.0039 36.7299 25.0039 41.2131V46.6249",
    stroke: "url(#paint2_linear_6582_55691)",
    strokeWidth: 4.02016,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6582_55691",
    x1: 19.1959,
    y1: 4.10406,
    x2: 53.1173,
    y2: 29.9065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84FAD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.577071,
    stopColor: "#EBBFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6EC85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6582_55691",
    x1: 23.8403,
    y1: 15.7007,
    x2: 47.8607,
    y2: 32.4494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84FAD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.577071,
    stopColor: "#EBBFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6EC85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6582_55691",
    x1: 28.4807,
    y1: 27.2971,
    x2: 42.0941,
    y2: 34.8909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84FAD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.577071,
    stopColor: "#EBBFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6EC85"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDream5);
export default __webpack_public_path__ + "static/media/icon-dream-5.018488c6e059a70edbf95ef93f2bd725.svg";
export { ForwardRef as ReactComponent };